import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View } from 'react-native';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { Order as ShopeeOrder } from '../../Order/rn';
import { FoodOrder } from '../../FoodOrder/rn';
import { OrderWithMoreBtn } from '../../OrderWithMoreBtn/rn'; // import { useComponentTracking } from '../../../hooks/useTracking';

import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
export var OrderType;
(function (OrderType) {
  OrderType["shopee"] = "shopee";
  OrderType["food"] = "food";
  OrderType["prediction"] = "prediction";
  OrderType["orderWithHotQuestion"] = "orderWithHotQuestion";
})(OrderType || (OrderType = {}));
export var OrderCardWithButton = function OrderCardWithButton(props) {
  var order = props.order,
    buttons = props.buttons,
    _props$orderType = props.orderType,
    orderType = _props$orderType === void 0 ? OrderType.shopee : _props$orderType,
    componentTrackingData = props.componentTrackingData;
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    orderCardTracking = _useComponentTracking.result.orderCard;
  return /*#__PURE__*/React.createElement(View, orderCardTracking === null || orderCardTracking === void 0 ? void 0 : orderCardTracking.trackingImpressionProps, orderType === OrderType.shopee || orderType === OrderType.orderWithHotQuestion ? /*#__PURE__*/React.createElement(ShopeeOrder, order) : null, orderType === OrderType.food ? /*#__PURE__*/React.createElement(FoodOrder, _extends({}, order, {
    wrapperStyle: [order.wrapperStyle, styles['order-card-with-button-food-order-container']]
  })) : null, orderType === OrderType.prediction ? /*#__PURE__*/React.createElement(OrderWithMoreBtn, props) : null, /*#__PURE__*/React.createElement(ButtonGroup, buttons));
};
var styles = CustomStyleSheet({
  'order-card-with-button-food-order-container': {
    minWidth: 300
  }
});